import React, { useContext, useState } from "react";
import { StoreContext } from "../../context/StoreContext";
import UserContext from "../../context/UserContext";
import { isContatNo, isEmpty, isNotPostiveNumber, stateInfo, isEmail } from "../../util/validate";

const UserForm = ({ title }) => {
  const userCtx = useContext(UserContext);
  const { data } = useContext(StoreContext);
  const storeDetails = data.store_master;
  const [user, setUser] = useState({
    name: userCtx.userInfo.name || "",
    contact: userCtx.userInfo.contact || "",
    email: userCtx.userInfo.email || "",
    state: userCtx.userInfo.state || "",
    state_id: userCtx.userInfo.state_id || "",
    city: userCtx.userInfo.city || "",
    country: "India"
  });
  const statesInfo = stateInfo(storeDetails);
  const [showDropdown, setShowDropdown] = useState(false);

  const filteredStates =
    user.state.trim().length > 0
      ? statesInfo.filter((zone) =>
        zone.name.toLowerCase().includes(user.state.toLowerCase())
      )
      : statesInfo || [];

  const [error, setError] = useState({
    name: false,
    contact: false,
    city: false,
  });

  const handleInputChange = (identifier, value, label) => {

    if (identifier === "state") {
      const selectedState = statesInfo.find((state) => state.name === value);
      setUser((prev) => ({
        ...prev,
        state: value,
        state_id: value || "",
      }));
      setError((prev) => ({
        ...prev,
        state: !selectedState,
      }));
    } else {
      setUser((prev) => ({
        ...prev,
        [identifier]: value,
      }));
    }

    if (identifier === "city" && value === "") {
      setError((prev) => ({
        ...prev,
        city: true,
      }));
    } else if (identifier === "city") {
      setError((prev) => ({
        ...prev,
        city: false,
      }));
    }

    if (identifier === "contact" && isContatNo(value)) {
      setError((prev) => ({
        ...prev,
        [identifier]: true,
      }));
    } else if (identifier === "email" && value !== "" && !isEmail(value)) {
      setError((prev) => ({
        ...prev,
        [identifier]: true,
      }));
    } else if (value === "" && identifier !== "email") {
      setError((prev) => ({
        ...prev,
        [identifier]: true,
      }));
    } else {
      setError((prev) => ({
        ...prev,
        [identifier]: false,
      }));
    }

  };

  const handleSubmitUser = (e) => {
    e.preventDefault();
    userCtx.updateUser(user);
  };

  var submitIsEnable = true;

  if (isEmpty(user.name)) {
    submitIsEnable = true;
  } else if (isContatNo(user.contact)) {
    submitIsEnable = true;
  } else if (isEmpty(user.state_id) && storeDetails[0].zones) {
    submitIsEnable = true;
  } else if (isEmpty(user.state)) {
    submitIsEnable = true;
  } else if (isEmpty(user.city)) {
    submitIsEnable = true;
  } else {
    submitIsEnable = false;
  }

  return (
    <form className="contact-popup ">
      <h2>
        {title} your <br /> Contact Details
      </h2>
      <span className="small-heading">to place order</span>
      <div className="form-group">
        <input
          type="text"
          className="form-control"
          placeholder="Customer Name "
          onChange={(e) => handleInputChange("name", e.target.value, "0")}
          value={user.name}
          style={{ color: storeDetails[0].primarycolorcode }}
        />
        {error.name && <div className="input-error">Enter your name</div>}
      </div>
      <div className="form-group ">
        <input
          type="number"
          className="form-control"
          placeholder="Contact Number"
          onChange={(e) => handleInputChange("contact", e.target.value, "0")}
          onKeyDown={(e) => isNotPostiveNumber(e.key) && e.preventDefault()}
          value={user.contact}
          style={{ color: storeDetails[0].primarycolorcode }}
          onWheel={(e) => e.target.blur()}
        />
        {error.contact && (
          <div className="input-error">Enter valid contact number</div>
        )}
      </div>
      <div className="form-group">
        <input
          type="text"
          className="form-control"
          placeholder="Customer Email "
          onChange={(e) => handleInputChange("email", e.target.value, "0")}
          value={user.email}
          style={{ color: storeDetails[0].primarycolorcode }}
        />
        {error.email && <div className="input-error">Enter valid Email ID</div>}
      </div>
      <div className="form-group" style={{ position: "relative" }}>
        <input
          type="text"
          className="form-control"
          placeholder="State"
          value={user.state}
          onChange={(e) => handleInputChange("state", e.target.value)}
          onFocus={() => setShowDropdown(true)}
          // onBlur={() => setTimeout(() => setShowDropdown(false), 100)}
          style={{ color: storeDetails[0]?.primarycolorcode || "#000" }}
          autoComplete="off"
        />
        {showDropdown && filteredStates.length > 0 && (
          <ul className="autocomplete-list">
            {filteredStates.map((zone) => (
              <li
                key={zone.zone_id}
                onClick={() => handleInputChange("state", zone.name)}
                className="autocomplete-item"
              >
                {zone.name}
              </li>
            ))}
          </ul>
        )}
        {error.state && <div className="input-error">Select a valid state</div>}
      </div>
      <div className="form-group">
        <input
          type="text"
          className="form-control"
          placeholder="City"
          onChange={(e) => handleInputChange("city", e.target.value, "0")}
          value={user.city}
          style={{ color: storeDetails[0].primarycolorcode }}
        />
        {error.city && <div className="input-error">Enter your city</div>}
      </div>
      <span className="bottom-txt">{storeDetails[0].contactnote}</span>
      <button
        className="custom-btn"
        disabled={submitIsEnable}
        onClick={(e) => handleSubmitUser(e)}
        style={{ backgroundColor: storeDetails[0].primarycolorcode }}
      >
        Confirm
      </button>
    </form>
  );
};

export default UserForm;
